<template>
  <div class="container">
    <div
      class="box_error_no_valido"
      v-if="value.inusual || value.dudas.length > 0 || error0919"
    >
      <p class="box_text_item">
        <img
          class="box_img"
          src="@/assets/img/1x/warning.svg"
          alt="Error domicilio"
        />
        {{ errorNormalizacion }}
      </p>
    </div>
    <wrap-container>
      <province-list
        class="cascade w100"
        :value="value.codProv"
        name="domicilio.codProv"
        @input="onCodProv"
        :scrollOnFocus="step4 ? false : true"
        quantumObfuscate
      />
    </wrap-container>

    <wrap-container class="grid-container grid-container--8-4">
      <city-list
        class="col1"
        name="domicilio.localidad"
        :value="value.localid"
        :codProv="value.codProv"
        @input="onLocalid"
        :scrollOnFocus="step4 ? false : true"
        quantumObfuscate
      />
      <number-input
        class="col2"
        label="Código postal"
        v-model="value.codPost"
        maxlength="5"
        name="codPost"
        :required="true"
        :value="value.codPost"
        :validation-error="
          parseInt(value.codPost) < 1000
            ? 'El código postal debe ser mayor a 1000'
            : null
        "
        @input="reset"
        quantumObfuscate
      />
    </wrap-container>
    <wrap-container>
      <floating-tip
        class="col1"
        description="Si tu dirección no coincide con los espacios que te mostramos, por favor, agregá lo que te falta en datos adicionales."
        :showInfoIcon="true"
      >
        <text-input
          class="col1"
          label="Calle, número, piso, departamento"
          v-model="value.desDomi"
          maxlength="80"
          name="desDomi"
          :required="true"
          @input="reset"
          inputmode="text"
          pattern="^[a-zA-Z0-9\s\/]*$"
          quantumObfuscate
        />
      </floating-tip>
    </wrap-container>
    <div
      class="radio_buttons"
      v-if="value.dudas.length > 0 && !value.desDomi.endsWith('S/N')"
    >
      <wrap-container>
        <section-label
          value="No encontramos tu dirección, te sugerimos alguna de las siguientes
          opciones:"
        />
      </wrap-container>

      <wrap-container class="opcion_dudas">
        <wrap-container class="input-group">
          <radio-item
            class="radio-item"
            v-for="[index, item] of value.dudas.entries()"
            :key="index"
            @input="setDomicilio(item)"
            :label="item.direccion + '\n' + item.localidad"
            quantumObfuscate
          />
        </wrap-container>
      </wrap-container>
    </div>

    <dropdown-component title="Agregar datos adicionales" :show="value.inusual">
      <additional-address-data
        :value="value"
        :entrecallesReq="entrecallesReq"
      />
    </dropdown-component>
  </div>
</template>

<script>
import get from "lodash/get";
import addressData from "@/mixins/address-data";
import WrapContainer from "@/components/core/Container";
import TextInput from "@/components/core/TextInput";
import NumberInput from "@/components/core/NumberInput";
import ProvinceList from "@/components/core/composite/combos/ProvinceList";
import CityList from "@/components/core/composite/combos/CityList";
import RadioItem from "@/components/core/custom/RadioItem";
import SectionLabel from "@/components/core/SectionLabel";
import DropdownComponent from "@/components/core/DropDown";
import AdditionalAddressData from "@/components/core/custom/AdditionalAddressData.vue";
import FloatingTip from "@/components/core/custom/FloatingTip";

export default {
  name: "AddressData",
  mixins: [addressData],
  components: {
    WrapContainer,
    TextInput,
    NumberInput,
    ProvinceList,
    CityList,
    RadioItem,
    SectionLabel,
    DropdownComponent,
    AdditionalAddressData,
    FloatingTip
  },
  props: {
    value: Object,
    otroDomicilio: Boolean,
    step4: Boolean,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showSelectOptions() {
      return get(this.value, "lineas", []).length > 0;
    },
    error0919() {
      return this.value.errores?.some(obj => obj.codigo === "CLE0919");
    },
    errorNormalizacion() {
      if (this.error0919) {
        return (
          "El domicilio ingresado ya fue cargado anteriormente y va a poder seleccionarlo en el paso " +
          this.config.pasos[
            Object.keys(this.config.pasos).filter(
              step => this.config.pasos[step].path === "/firma"
            )[0]
          ].paso
        );
      }
      if (this.value.dudas && this.value.dudas.length > 0) {
        return "No pudimos encontrar tu dirección. Elegí tu domicilio entre las opciones más abajo.";
      }
      return "No pudimos encontrar tu dirección. Revisá que no haya ningún error y volvé a intentar.";
    },
    entrecallesReq() {
      return this.value.inusual;
    }
  },
  methods: {
    setDomicilio(domicilio) {
      const desDomi = domicilio.direccion;
      const localid = domicilio.localidad;
      const codPost = domicilio.codPost || this.value.codPost;
      const codProv = domicilio.codProv;
      const inusual = false;
      const calle1 = "";
      const calle2 = "";
      this.$emit("input", {
        ...this.value,
        ...{ desDomi, localid, codPost, codProv, inusual, calle1, calle2 }
      });
    },
    reset() {
      const inusual = false;
      const calle1 = "";
      const calle2 = "";

      this.$emit("input", {
        ...this.value,
        ...{ inusual, calle1, calle2 }
      });
    }
  }
};
</script>

<style scoped>
.box_error_no_valido {
  width: 100%;
  margin: 16px 0px 0px;
  padding: 16px;
  border-radius: 1px;
  box-shadow: 0 1px 3px 0 rgba(18, 18, 18, 0.2);
  background-color: #f8e9e9;
  margin-bottom: 5%;
}

.opcion_dudas {
  margin-top: 28px;
}

.box_text_item {
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  color: #121212;
  margin: 0px;
  display: inline-block;
}

.box_text_item img {
  width: 24px;
  display: block;
  margin-bottom: 16px;
}

.radio-item {
  display: grid;
  grid-template-columns: 30px 1fr;
  margin-bottom: 16px;
}
</style>
